import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { LayoutDashboard, Home, HelpCircle, BarChart3, BookOpen } from 'lucide-react';

export default function AdminLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState<any>(null);

    useEffect(() => {
        const token = localStorage.getItem('admin_token');
        const storedUser = localStorage.getItem('admin_user');

        if (!token) {
            navigate('/admin/login');
            return;
        }

        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        navigate('/admin/login');
    };

    if (!user) return null; // or loading spinner

    const navItems = [
        { label: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
        { label: 'Homepage', path: '/admin/homepage', icon: Home },
        { label: 'Quiz', path: '/admin/quiz', icon: HelpCircle },
        { label: 'Resultados', path: '/admin/results', icon: BarChart3 },
        { label: 'Cursos', path: '/admin/courses', icon: BookOpen },
    ];

    return (
        <div className="min-h-screen flex bg-gray-50">
            {/* Sidebar */}
            <aside className="w-64 bg-white border-r border-gray-200 hidden md:block">
                <div className="p-6">
                    <img
                        src="/logo-sebrae-mg.svg"
                        alt="Logo Sebrae"
                        className="h-10 w-auto mb-4"
                    />
                    <h1 className="text-xl font-bold text-blue-600">Maturidade Digital</h1>
                    <p className="text-xs text-gray-500 uppercase tracking-wider mt-1">Admin Panel</p>
                </div>
                <nav className="mt-6">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 px-6 py-3 text-sm font-medium ${location.pathname.startsWith(item.path)
                                ? 'text-blue-600 bg-blue-50 border-r-2 border-blue-600'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                }`}
                        >
                            <item.icon className="h-4 w-4" />
                            {item.label}
                        </Link>
                    ))}
                </nav>
                <div className="absolute bottom-0 w-64 p-4 border-t border-gray-200">
                    <div className="flex items-center mb-4">
                        <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                            {user.first_name?.[0] || 'A'}
                        </div>
                        <div className="ml-3">
                            <p className="text-sm font-medium text-gray-700">{user.first_name} {user.last_name}</p>
                            <p className="text-xs text-gray-500 truncate w-32">{user.email}</p>
                        </div>
                    </div>
                    <Button variant="outline" className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50" onClick={handleLogout}>
                        Sair
                    </Button>
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-1 overflow-y-auto">
                <div className="p-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
